/* ==========================================================================
   TRE EMME — CX listing: live filters, load more, back link (collection + search)
   Uses the Section Rendering API so results update without a page reload.
   ========================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';
  const plp = document.querySelector('[data-cx-plp]');
  if (!plp || !window.CX) return;
  const { $, $$, toast, watchImages } = window.CX;
  const sectionId = plp.dataset.section;
  const parser = new DOMParser();
  let controller = null;

  const sectionUrl = (url) => {
    const u = new URL(url, location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  };

  const fetchDoc = (url) => {
    if (controller) controller.abort();
    controller = new AbortController();
    return fetch(sectionUrl(url), { signal: controller.signal, credentials: 'same-origin' })
      .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then((html) => parser.parseFromString(html, 'text/html'));
  };

  /* Back: use history when we came from this site */
  $$('[data-cx-back]', plp).forEach((a) => a.addEventListener('click', (e) => {
    if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
      e.preventDefault();
      history.back();
    }
  }));

  /* Filters — the drawer is moved to <body> so no ancestor can trap it under the page */
  const drawer = document.getElementById('cx-filters');
  if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);
  // Phones: every group starts collapsed (sort included), the list stays short and scannable
  const phone = window.matchMedia('(max-width: 767px)');
  document.addEventListener('click', (e) => {
    if (!phone.matches || !drawer || !e.target.closest('[data-cx-open="cx-filters"]')) return;
    $$('details', drawer).forEach((d) => { d.open = false; });
  }, true);
  const form = $('[data-cx-filters]');
  const urlFromForm = () => {
    const data = new FormData(form);
    const params = new URLSearchParams();
    for (const [k, v] of data.entries()) if (v !== '') params.append(k, v);
    return `${form.action.split('?')[0]}?${params.toString()}`;
  };

  const swap = (doc) => {
    const count = $('[data-cx-results] [data-cx-count]', doc);
    const total = count ? count.dataset.cxCount : null;
    const results = $('[data-cx-results]', plp);
    const nextResults = $('[data-cx-results]', doc);
    if (results && nextResults) results.replaceWith(nextResults);

    const body = form && $('[data-cx-filters-body]', form);
    const nextBody = $('[data-cx-filters-body]', doc);
    if (body && nextBody) {
      const openIdx = $$('details', body).map((d, i) => (d.open ? i : -1)).filter((i) => i > -1);
      const focusName = document.activeElement && body.contains(document.activeElement)
        ? `${document.activeElement.name}|${document.activeElement.value}` : null;
      body.replaceWith(nextBody);
      $$('details', nextBody).forEach((d, i) => { if (openIdx.includes(i)) d.open = true; });
      if (focusName) {
        const [n, v] = focusName.split('|');
        const el = $$('input', nextBody).find((i) => i.name === n && (i.type === 'number' || i.value === v));
        el && el.focus({ preventScroll: true });
      }
    }

    const countTarget = form && $('[data-cx-filters-count]', form);
    if (total !== null && countTarget) countTarget.textContent = total;

    const badge = $('[data-cx-filter-badge]', plp);
    const nextBadge = $('[data-cx-filter-badge]', doc);
    if (badge && nextBadge) { badge.textContent = nextBadge.textContent; badge.hidden = nextBadge.hidden; }

    watchImages(plp);
    bindMore();
  };

  let goId = 0;
  const go = (url, push = true) => {
    const id = ++goId;
    plp.classList.add('is-loading');
    return fetchDoc(url).then((doc) => {
      swap(doc);
      if (push) history.replaceState({}, '', url);
    }).catch((err) => {
      if (err.name !== 'AbortError') location.href = url;
    }).finally(() => { if (id === goId) plp.classList.remove('is-loading'); }); // an aborted request must not end a newer one's loading state
  };

  if (form) {
    let timer;
    form.addEventListener('change', () => {
      // A response still in flight would swap in a filters body without this latest tick: drop it
      if (controller) controller.abort();
      clearTimeout(timer);
      timer = setTimeout(() => go(urlFromForm()), 250);
    });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      clearTimeout(timer);
      go(urlFromForm()).then(() => {
        const close = $('[data-cx-close]', form.closest('[data-cx-drawer]'));
        close && close.click();
        const results = $('[data-cx-results]', plp);
        results && results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    const clear = $('[data-cx-filters-clear]', form);
    clear && clear.addEventListener('click', (e) => { e.preventDefault(); go(clear.href); });
  }

  plp.addEventListener('click', (e) => {
    const link = e.target.closest('[data-cx-filter-link]');
    if (!link) return;
    e.preventDefault();
    go(link.href);
  });

  /* Load more — append the next page in place, keep a real link as fallback */
  function bindMore() {
    const more = $('[data-cx-more]', plp);
    if (!more || more.dataset.bound) return;
    more.dataset.bound = '1';
    more.addEventListener('click', (e) => {
      e.preventDefault();
      if (more.classList.contains('is-loading')) return;
      more.classList.add('is-loading');
      fetchDoc(more.href).then((doc) => {
        const grid = $('[data-cx-grid]', plp);
        const items = $$('[data-cx-grid] > .cx-plp__item:not(.cx-plp__banner)', doc);
        items.forEach((item, i) => {
          item.style.setProperty('--i', Math.min(i, 8));
          item.classList.add('is-new');
          grid.appendChild(item);
        });
        const wrap = $('[data-cx-more-wrap]', plp);
        const nextWrap = $('[data-cx-more-wrap]', doc);
        if (wrap && nextWrap) wrap.replaceWith(nextWrap); else if (wrap) wrap.remove();
        watchImages(grid);
        bindMore();
        const first = items[0] && $('a[href]', items[0]);
        first && first.focus({ preventScroll: true });
      }).catch((err) => {
        if (err.name === 'AbortError') return;
        more.classList.remove('is-loading');
        toast('Impossibile caricare altri prodotti.', { type: 'error' });
      });
    });
  }
  bindMore();

  /* Keep the HUD offset in sync with the sticky header */
  const hud = $('[data-cx-hud]', plp);
  if (hud && 'IntersectionObserver' in window) {
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    hud.before(sentinel);
    new IntersectionObserver(([entry]) => hud.classList.toggle('is-stuck', !entry.isIntersecting), { rootMargin: '-80px 0px 0px 0px' }).observe(sentinel);
  }
});
